module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/proposes"
    }
  }, [_vm._v(_vm._s(_vm.$t('Propose')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/propose_task_list"
    }
  }, [_vm._v(_vm._s(_vm.$t('Propose Title')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Propose Title Edit')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Propose Title Edit')))]), (true) ? _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("タイトル")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title.content),
      expression: "title.content"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "30",
      "placeholder": "提案タイトル"
    },
    domProps: {
      "value": _vm._s(_vm.title.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title.content = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.hasContent),
      expression: "!validation.hasContent"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])]), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('p', {
    staticClass: "text-right",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.title.content.length) + " / 30")])])])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("公開年月日")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title.startDate),
      expression: "title.startDate"
    }],
    attrs: {
      "placeholder": "開始日"
    },
    domProps: {
      "value": (_vm.title.startDate)
    },
    on: {
      "input": function($event) {
        _vm.title.startDate = $event
      }
    }
  }), _c('span', [_vm._v(" 〜 ")]), _c('el-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title.endDate),
      expression: "title.endDate"
    }],
    attrs: {
      "placeholder": "終了日"
    },
    domProps: {
      "value": (_vm.title.endDate)
    },
    on: {
      "input": function($event) {
        _vm.title.endDate = $event
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.isValidRange),
      expression: "!validation.isValidRange"
    }],
    staticClass: "validation-msg"
  }, [_vm._v("開始日＞＝終了日になっています。")]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.isFuture),
      expression: "!validation.isFuture"
    }],
    staticClass: "validation-msg"
  }, [_vm._v("明日以降を入力してください。")])], 1)]), _c('div', {
    staticClass: "form-group text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm margin-right",
    attrs: {
      "type": "button",
      "disabled": !_vm.validation.isAllClear
    },
    on: {
      "click": _vm.updateTask
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])]), _c('button', {
    staticClass: "btn btn-danger btn-sm margin-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteTask
    }
  }, [_vm._v(_vm._s(_vm.$t('Delete')))]), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goProposeTaskList
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70825727!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/propose-task-edit.pug
// module id = 875
// module chunks = 1